import { Camera, X } from 'lucide-react';

interface PhotoInputProps {
  preview: string | null;
  onFileChange: (file: File, previewUrl: string) => void;
  onDelete?: () => void;
  placeholderIcon?: React.ReactNode;
  label?: string;
}

export function PhotoInput({
  preview,
  onFileChange,
  onDelete,
  placeholderIcon,
  label,
}: PhotoInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      onFileChange(file, reader.result as string);
    };
    reader.readAsDataURL(file);
  };

  return (
    <div>
      {label && (
        <p className="block text-sm font-medium text-theme-primary mb-2">{label}</p>
      )}
      <div className="flex items-center gap-4">
        <div className="relative group">
          {preview ? (
            <>
              <img src={preview} alt="Preview" className="w-20 h-20 object-cover rounded-lg border border-line" />
              {onDelete && (
                <button
                  type="button"
                  onClick={onDelete}
                  className="absolute -top-2 -right-2 p-1 bg-red-600 text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                >
                  <X size={12} />
                </button>
              )}
            </>
          ) : (
            <div className="w-20 h-20 bg-subtle rounded-lg flex items-center justify-center">
              {placeholderIcon ?? <Camera size={24} className="text-theme-secondary" />}
            </div>
          )}
        </div>
        <label className="flex items-center gap-2 px-4 py-2 bg-subtle text-theme-primary rounded-lg cursor-pointer hover:bg-subtle transition-colors">
          <Camera size={18} />
          {preview ? 'Change Photo' : 'Add Photo'}
          <input
            type="file"
            accept="image/jpeg,image/png,image/webp,image/heic,image/heif,image/gif"
            onChange={handleChange}
            className="hidden"
          />
        </label>
      </div>
    </div>
  );
}
